import { API_AUTH } from ".././common";

const DanhDachIcloudApi = {
  list: ({
    SoDienThoai,
    TenTaiKhoan,
    SoHDLienKet,
    iHanChe,
    iLock,
    iPageIndex,
    iPageSize,
  }) =>
    API_AUTH.get(
      `taikhoanicloud/danhsach?SoDienThoai=${SoDienThoai}&TenTaiKhoan=${TenTaiKhoan}&SoHDLienKet=${SoHDLienKet}&iHanChe=${iHanChe}&iLock=${iLock}&iPageIndex=${iPageIndex}&iPageSize=${iPageSize}`,
      {}
    ),
  addOrUpdate: (params) => API_AUTH.post("taikhoanicloud/addorupdate", params),
  delete: ({ IdICloud }) =>
    API_AUTH.post("taikhoanicloud/delete?IdICloud=" + IdICloud),
  lstLichSuSuaTaiKhoan: (id) =>
    API_AUTH.get(`taikhoanicloud/lstLichSuSuaTaiKhoan?id=${id}`, {}),
  lstHopDongLienKet: (id) =>
    API_AUTH.get(`taikhoanicloud/lstHopDongLienKet?id=${id}`, {}),
  getTaiKhoanLienKetByMaHopDong: (MaHopDong) =>
    API_AUTH.get(
      `taikhoanicloud/GetTaiKhoanLienKetByMaHopDong?MaHopDong=${MaHopDong}`,
      {}
    ),
  setKhoaTaiKhoan: ({ IdICloud, isLock }) =>
    API_AUTH.post(
      "taikhoanicloud/setKhoaTaiKhoan?IdICloud=" +
        IdICloud +
        "&isLock=" +
        isLock
    ),
};

export default DanhDachIcloudApi;
